// A file dropped where nothing takes it opens in the tab, which leaves the page and ends every
// running upload (and, in the editor, the open project). Screens that take dropped files refuse
// the rest of the window's drops through this one hook.
import { useEffect } from "react";

/**
 * While the calling screen is mounted, the window refuses a file dropped where nothing takes it.
 * The screen's own drop handlers run first and prevent the default where they take the drop;
 * anywhere else the cursor says "no" (`dropEffect: none`) and the drop does nothing. Drags that
 * carry no files (a clip moved on the timeline) are left alone.
 */
export function useRefuseStrayFileDrops(): void {
  useEffect(() => {
    const refuse = (event: DragEvent) => {
      const transfer = event.dataTransfer;
      // Read as possibly absent: a synthetic drag (a test's, another library's) may carry none.
      const types: readonly string[] | undefined = transfer?.types;
      if (transfer === null || types?.includes("Files") !== true || event.defaultPrevented) return;
      event.preventDefault();
      if (event.type === "dragover") transfer.dropEffect = "none";
    };
    window.addEventListener("dragover", refuse);
    window.addEventListener("drop", refuse);
    return () => {
      window.removeEventListener("dragover", refuse);
      window.removeEventListener("drop", refuse);
    };
  }, []);
}
